module.exports = __webpack_public_path__ + "202408221624/img/color_1.778d3764.png";